import React from "react";
import { TEAM } from "../data/site";
import { Instagram } from "lucide-react";

export default function Team() {
    return (
        <section
            id="team"
            data-testid="team-section"
            className="relative py-24 sm:py-32 bg-ink-surface/40 border-y border-white/5"
        >
            <div className="container mx-auto px-4 sm:px-6 lg:px-10">
                <div className="max-w-3xl">
                    <div className="font-manrope text-sm uppercase tracking-[0.3em] text-gold mb-4">
                        Il Team
                    </div>
                    <h2
                        data-testid="team-title"
                        className="font-oswald font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]"
                    >
                        I coach di <span className="text-shimmer">RPF</span>
                    </h2>
                    <p className="mt-6 font-manrope text-zinc-400 text-base sm:text-lg max-w-2xl">
                        Un gruppo di professionisti uniti da una sola ossessione: darti il
                        miglior servizio possibile.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6 sm:gap-8">
                    {TEAM.map((m, i) => (
                        <div
                            key={m.name}
                            data-testid={`team-member-${i}`}
                            className="group relative overflow-hidden bg-ink border border-white/5 rounded-xl hover:border-gold/40 hover:-translate-y-1 transition-all duration-500"
                        >
                            {/* Logo banner */}
                            <div className="relative aspect-[16/10] overflow-hidden bg-black flex items-center justify-center">
                                <img
                                    src={m.logo}
                                    alt={m.name}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent opacity-60" />
                            </div>

                            <div className="p-6 sm:p-7">
                                <div className="font-oswald font-bold text-xl text-white uppercase tracking-wide leading-tight">
                                    {m.name}
                                </div>
                                <div className="font-manrope text-xs uppercase tracking-[0.25em] text-gold mt-2">
                                    {m.role}
                                </div>
                                <p className="mt-4 font-manrope text-zinc-400 text-sm leading-relaxed">
                                    {m.bio}
                                </p>
                                <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
                                    <span className="font-manrope text-xs uppercase tracking-widest text-zinc-500">
                                        {m.igHandle}
                                    </span>
                                    <a
                                        href={m.instagram}
                                        target="_blank"
                                        rel="noopener"
                                        aria-label={`Instagram ${m.name}`}
                                        className="text-zinc-500 hover:text-gold transition-colors"
                                    >
                                        <Instagram size={16} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
